import React from "react";
import { useLocation } from "react-router-dom";
import ModuleSubtopic from "../../../ModuleSubtopic";

const ModuleSubtopicInstructionSets = () => {
  const location = useLocation();
  const { subtopics, subjectPath } = location.state || { subtopics: [], subjectPath: '' };

  return (
    <ModuleSubtopic
      subtopics={subtopics}
      subjectPath={subjectPath}
      title="INSTRUCTION SETS AND INSTRUCTION SET FORMATS"
      videos={[
        "https://www.youtube.com/embed/r6PChksvxp8",
        "https://www.youtube.com/embed/icFfxkg1p4o"
      ]}
      takeaways={[
        { text: "Classification of Instructions" ,
         image: "/cao_2.png"},

       
        
      ]}
      questions={[]}
      exampleVideos={[]}
    />
);
}

export default ModuleSubtopicInstructionSets;